import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/static/icons/close.svg'
import _imports_1 from '@/static/icons/checkmark_icon.svg'


const _hoisted_1 = { class: "sort__dropdown-header" }
const _hoisted_2 = { class: "sort__dropdown-header-title" }
const _hoisted_3 = { class: "sort-option__text" }
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  class: "arrow"
}

import { computed, ref, watch } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { getContext } from '@/composables/useDynamicProductListing';

import Dropdown from '../forms/Dropdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sort',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const {
  selectedSortOption,
  sortOptions,
  isMobile,
  isSortDropwdownOpen,
  setSortOption,
  toggleElementAnimation,
} = getContext();

const dropdownEl = ref<InstanceType<typeof Dropdown> | null>(null);

const sortToLabelMap = computed(() => ({
  popularity: websiteText('category__sorting_popularity').value,
  nameasc: websiteText('category__sorting_name_asc').value,
  namedesc: websiteText('category__sorting_name_desc').value,
  priceasc: websiteText('category__sorting_price_asc').value,
  pricedesc: websiteText('category__sorting_price_desc').value,
}));

const sortButtonLabel = computed(() => {
  const currentSortValue = selectedSortOption.value || 'popularity';
  const label = sortToLabelMap.value[currentSortValue] || currentSortValue;
  const category__sorting = websiteText('category__sorting').value;
  return `${category__sorting}: ${label.toString()}`;
});

const sortFacetValues = computed(() =>
  sortOptions.map((option) => ({
    value: option,
    text: sortToLabelMap.value[option] || option,
    isSelected: false,
  }))
);

function closeDropdown() {
  dropdownEl.value?.closeDropdown();
}

function toggleSortOverlay(isDropdownOpen: boolean) {
  isSortDropwdownOpen.value = isDropdownOpen;
  if (isDropdownOpen && isMobile.value) {
    toggleElementAnimation(
      'sort__slide-up',
      dropdownEl.value?.$refs?.dropdown as HTMLDivElement
    );
    const overlay = document.createElement('div');
    overlay.id = 'sort-overlay';
    overlay.className = 'sort__overlay';

    document.body.appendChild(overlay);
    document.body.classList.add('sort__body-no-scroll');
  } else {
    toggleElementAnimation(
      'sort__slide-down',
      dropdownEl.value?.$refs?.dropdown as HTMLDivElement
    );
    const overlay = document.getElementById('sort-overlay');
    if (overlay) {
      overlay.remove();
      document.body.classList.remove('sort__body-no-scroll');
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dropdown, {
    class: "sort",
    options: _unref(sortFacetValues),
    "v-model": _unref(selectedSortOption),
    onChange: _cache[0] || (_cache[0] = (sortOption) => _unref(setSortOption)(sortOption.value)),
    onExpanded: toggleSortOverlay,
    placeholder: _unref(sortButtonLabel),
    ref_key: "dropdownEl",
    ref: dropdownEl
  }, {
    additionaloption: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(websiteText)('category__sorting_by').value), 1),
        _createElementVNode("img", {
          src: _imports_0,
          class: "sort__dropdown-header-close",
          onClick: closeDropdown
        })
      ])
    ]),
    selected: _withCtx((slotProps) => [
      _createElementVNode("span", _hoisted_3, _toDisplayString(slotProps.selected.text), 1)
    ]),
    option: _withCtx((slotProps) => [
      _createElementVNode("div", {
        class: _normalizeClass(["sort-option__text", {
          'sort-option__text--selected':
            slotProps.option.value === _unref(selectedSortOption),
        }])
      }, [
        (slotProps.option.value === _unref(selectedSortOption))
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(slotProps.option.text), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["options", "v-model", "placeholder"]))
}
}

})